export function regionSort(a,b) {
	return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
}

export function sortByAvailableAndFloor(a, b) {
	const aFloor = Number(a.floor.substr(0,1)) || 0;
	const bFloor = Number(b.floor.substr(0,1)) || 0;

	return (a.isFree && b.isFree) || (!a.isFree && !b.isFree) ?
		aFloor === bFloor ? 0 : bFloor - aFloor
		: a.isFree ? -1 : 1;
}
